<div style="overflow: auto; height: calc(100vh - 220px)">
    <p class="text-muted small mt-2">
        These rows show how far the extracted invoices can be trusted. Line checks use the selected dates, category, and item search. Flagged
        invoices, subtotal mismatches, and credit memos use the selected dates and include every category. Unusable dates are missing, before 2015,
        or after today, so they sit outside the selected range. Credit memos are left out of the other tabs.
    </p>
    @if (cards.length) {
        <div class="row g-3 mb-3">
            @for (card of cards; track card.key) {
                <div class="col-md-3">
                    <button
                        type="button"
                        class="card h-100 w-100 text-start"
                        [class.text-bg-light]="selected !== card.key"
                        [class.text-bg-primary]="selected === card.key"
                        (click)="show(card.key)"
                    >
                        <div class="card-body">
                            <div class="small" [class.text-muted]="selected !== card.key">{{ card.title }}</div>
                            <div class="fs-3 fw-bold">{{ card.count | number }}</div>
                            @if (card.amount != null) {
                                <div class="small">{{ card.amount | currency }}</div>
                            }
                        </div>
                    </button>
                </div>
            }
        </div>
    }
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="exampleGrid"></action-toolbar-count>
                <grid-export [grid]="gridDataQuality" [name]="'Purchased Material Data Quality'"></grid-export>
                @if (selectedCard?.examplesTruncated) {
                    <span class="text-muted small">Showing {{ exampleLimit | number }} of {{ selectedCard?.count | number }}</span>
                }
            </form>
        </div>
    </div>
    <grid-column-group [grid]="exampleGrid"></grid-column-group>
    <wj-flex-grid
        id="gridDataQuality"
        #gridDataQuality
        style="height: 420px"
        [isReadOnly]="true"
        (initialized)="exampleGrid.initialize(gridDataQuality)"
        (destroy)="exampleGrid.destroy()"
        [itemsSource]="exampleGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Invoice'" [binding]="'invoiceNumber'" [width]="160" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Vendor'" [binding]="'vendor'" [width]="240" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Date'" [binding]="'invoiceDate'" [width]="110" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Issue'" [binding]="'issue'" [width]="420" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="320" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridDataQuality"></grid-selection-calculation>
</div>
